import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { accountsEnvironment } from './accounts-environment';
import { metricLogResponseSchema } from './schemas/metric-logs.schema';

export function postUsersLogs(
  externalIds: string[],
  startDate: Date,
  endDate: Date
) {
  return fromFetch(
    new Request(accountsEnvironment.usersLogsUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify({
        externalIds,
        startDate,
        endDate,
      }),
    })
  ).pipe(selectData(metricLogResponseSchema));
}
